import React, { PropTypes, PureComponent } from 'react';

export const Relative = ({ style, children, ...rest }) => (
  <div style={{ ...style, position: 'relative' }} {...rest}>{children}</div>
);

export const Absolute = ({ style, ...rest }) => (
  <div style={{ ...style, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} {...rest}/>
);

export const FILL_SPACE = { height: '100%', width: '100%' };


// WEBPACK FOOTER //
// ./src/js/common/components/Fill.jsx